import { FC } from 'react';
import { IconType } from 'react-icons';
import { BsPlusCircle } from 'react-icons/bs';
import { ButtonProps, Flex, FlexProps, Icon } from '@chakra-ui/react';

type AddAdditionalContentButtonProps = FlexProps &
  ButtonProps & {
    icon?: IconType;
  };

export const AddAdditionalContentButton: FC<
  AddAdditionalContentButtonProps
> = ({ children, icon = BsPlusCircle, ...props }) => (
  <Flex
    alignItems="center"
    asChild
    bg="gray.25"
    borderRadius="sm"
    justifyContent="center"
    p={4}
    {...props}
  >
    <button type="button">
      <Icon as={icon} boxSize={5} mr={2.5} />
      {children}
    </button>
  </Flex>
);
